import type { FC } from 'react';
import { lazy } from 'react';
import type { AssignmentServiceRequest } from 'src/apis/assignment-service/use-assignment-service-root';
import { useOptionalMasterDataInterfaceConfiguration } from 'src/apis/assignment-service/use-optional-master-data-interface-configuration';
import { PageSpinner } from 'src/components/spinner-container';
import type { Successful } from 'src/hooks/use-axios';
import { Forbidden } from 'src/utils/errors';

const Page = lazy(
  () =>
    import(
      'src/pages/settings/assignment-settings/master-data-interface-configuration/edit/page'
    )
);

type AssignmentServiceProps = {
  assignmentService: Successful<AssignmentServiceRequest>;
};

export const EditMasterDataInterfaceConfiguration: FC<
  AssignmentServiceProps
> = ({ assignmentService }) => {
  if (
    !assignmentService.response.data._links.getMasterDataInterfaceConfiguration
  ) {
    throw new Forbidden();
  }

  const masterDataInterfaceConfiguration =
    useOptionalMasterDataInterfaceConfiguration(
      assignmentService.response.data._links.getMasterDataInterfaceConfiguration
        .href
    );

  if (!masterDataInterfaceConfiguration?.response) return <PageSpinner />;

  return (
    <Page masterDataInterfaceConfiguration={masterDataInterfaceConfiguration} />
  );
};
